import React, { useState } from "react";
import { Check } from "lucide-react";

export function toggleArticleCompanyUnit(form, unitId, selected) {
  const id = Number(unitId);
  if (!Number.isInteger(id) || id <= 0) return form;
  const details = form.articleotherDetails || [];
  const matches = detail => Number(detail.companyUnitId) === id && !detail.isBaseRow;
  if (!selected) {
    return { ...form, articleotherDetails: details.filter(detail => !matches(detail)) };
  }
  if (details.some(matches)) return form;
  return { ...form, articleotherDetails: [...details, {
    isActive: true,
    companyUnitId: id,
    typeOfSales: 1,
    newBarcode: form.barcode,
    articleUnitID: form.unitId,
    articleUnitQty: null,
    newSalesPrice: form.salePriceWithVat,
  }] };
}

export default function ArticleCompanyUnits({ units, details, onToggle, disabled = false }) {
  const [search, setSearch] = useState("");
  const selectedIds = new Set(details.map(detail => Number(detail.companyUnitId)));
  const selectedCount = units.filter(unit => selectedIds.has(Number(unit.UnitID))).length;
  const visibleUnits = units.filter(unit => String(unit.UnitName || "").toLocaleLowerCase().includes(search.trim().toLocaleLowerCase()));
  return (
    <fieldset className="article-company-picker" disabled={disabled}>
      <legend>Ku shfaqet artikulli?</legend>
      <div className="article-company-picker__summary">{selectedCount} nga {units.length} njësi të zgjedhura</div>
      {units.length > 8 && (
        <input className="article-company-picker__search" type="search" aria-label="Kërko njësi organizative"
          placeholder="Kërko njësinë…" value={search} onChange={event => setSearch(event.target.value)} />
      )}
      <div className="article-company-picker__options">
        {visibleUnits.map(unit => (
          <label key={unit.UnitID} className="article-company-picker__option">
            <input className="article-company-picker__input" type="checkbox" checked={selectedIds.has(Number(unit.UnitID))}
              onChange={event => onToggle(unit.UnitID, event.target.checked)} />
            <span className="article-company-picker__check" aria-hidden="true"><Check size={14} strokeWidth={3} /></span>
            <span>{unit.UnitName}</span>
          </label>
        ))}
        {visibleUnits.length === 0 && <span className="article-company-picker__empty">Nuk u gjet asnjë njësi.</span>}
      </div>
    </fieldset>
  );
}
